export default {
    AddInternalRefundOnlyDoc: {
        Associate: '关联销售单',
        Select: '选择关联销售单',
        Basic: '基础信息',
        Refund: '退款单类型',
        type: '退款类型',
        Tripartite: '三方退款单号',
        Three: '三方退款时间',
        reason: '退款原因',
        stage: '退款阶段',
        Customer: '客服备注',
        Financial: '财务信息',
        Settlement: '结算方式',
        Product: '商品信息',
        Add: '添加退款商品',
        Image: '图片附件',
        an: '选择关联销售单',
        the: '选择退款的商品',
        sales: '关联销售单：',
        Other: '其它',
        Unshipped: '未发货数量：',
        Quantity: '已退款数量：',
        Refundable: '可退款数量：',
        Shipment: '发货状态：',
        Preemption: '预占状态：',
        Sourcing: '寻源状态：',
        selectform: '请选择退款单类型',
        selecttype: '请选择退款类型',
        enternumber: '请输入三方退款单号',
        selectrefund: '请选择三方退款时间',
        selectreason: '请选择退款原因',
        selectstage: '请选择退款阶段',
        selectmethod: '请选择结算方式',
        Delete: '删除',
        form: {
            Giveaway: '是否赠品',
            Product: '商品行数量',
            Refundable: '可退款数量',
            Refund: '退款数量',
            unit: '退款单价',
            Total: '退款合计',
        },
        info: {
            Please: '请先选择关联销售单',
            add: '请先添加退款商品',
            Deletion: '删除成功',
            an: '请先选择关联销售单',
            The: '可退款数量为0',
            returned: '返回数据为空，请联系管理员',
        },
    }
};
